const SIDEBAR_OPEN_STORAGE_KEY = 'payment-service:sidebar-open'

export function getInitialSidebarState() {
  if (typeof window === 'undefined') {
    return true
  }

  try {
    const storedState = window.localStorage.getItem(SIDEBAR_OPEN_STORAGE_KEY)

    if (storedState === null) {
      return true
    }

    return storedState === 'true'
  } catch (error) {
    console.error('Error reading sidebar state from localStorage:', error)

    return true
  }
}

export function persistSidebarState(isOpen: boolean) {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.localStorage.setItem(SIDEBAR_OPEN_STORAGE_KEY, String(isOpen))
  } catch (error) {
    console.error('Error storing sidebar state in localStorage:', error)
  }
}
